import HttpBaseService from '@/services/http/HttpBaseService'

class MeService extends HttpBaseService {

  updateUserInfo = (payload) => {
    return this.executeRequest('/api/me/info', 'PUT', payload)
  }

  preCheckinUpdateUserInfo = (payload) => {
    return this.executeRequest('/api/me/info/pre-checkin', 'PUT', payload)
  }

  getAllBookings = () => {
    return this.executeRequest('/api/me/get-reservations', 'GET')
  }

  getBooking = (externalId) => {
    return this.executeRequest('/api/mews/get-reservation-by-id/' + externalId, 'GET')
  }

  getFriendQR = () => {
    return this.executeRequest('/api/me/friend-qr',  'GET')
  }

}

export default new MeService()
